
import WifiNetworks from 'src/components/WifiNetworks'

const Page = () => {
  return (
    <>
      <WifiNetworks type='android-local' />
    </>
  )
}

export default Page
